/* eslint-disable import/no-extraneous-dependencies */

import Vue from 'vue';
import 'froala-editor/js/froala_editor.pkgd.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/plugins/code_view.min.css';
import 'froala-editor/js/plugins/paragraph_format.min';
import 'froala-editor/js/plugins/font_family.min';
import 'froala-editor/js/plugins/colors.min';
import 'froala-editor/js/plugins/code_view.min';
import 'froala-editor/js/plugins/align.min';
import 'froala-editor/js/plugins/lists.min';
import 'froala-editor/js/plugins/quote.min';
import 'froala-editor/js/plugins/link.min';
import 'froala-editor/js/plugins/table.min';
import 'froala-editor/js/plugins/image.min';
import VueFroala from 'vue-froala-wysiwyg';
import FroalaEditor from 'froala-editor';

Vue.use(VueFroala);

// Chart plugin
// $.FroalaEditor.DefineIcon('chart', { NAME: 'chart-bar' });

// $.FroalaEditor.RegisterCommand('chart', {
//     title: 'Insert Chart',
//     focus: true,
//     undo: true,
//     refreshAfterCallback: true,
//     callback() {
//         this.events.trigger('chart.insert');
//     },
// });

// Customize icons
FroalaEditor.DefineIcon('paragraphFormat', { NAME: 'heading' });
